import { Component, OnInit, HostListener, ElementRef, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectDropdownComponent),
      multi: true
    }
  ]
})
export class MultiSelectDropdownComponent implements OnInit, ControlValueAccessor {

  @Input() dropdownItems: any[] = [];

  @Input() dropdownOnTop: boolean = false;

  @Input() placeHolder: string = "-- select items --";

  selectedItems: number[] = []; // Store only item keys
  filteredItems: { key: number, name: string }[] = [];
  searchTerm: string = '';
  selectAllChecked: boolean = false;
  dropdownVisible: boolean = false;

  private onChange = (value: any) => {};
  private onTouched = () => {};

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    this.filteredItems = [...this.dropdownItems];    
  }

  ngOnChanges() {
    this.filteredItems = [...this.dropdownItems];    
  }

  filterItems() {
    this.filteredItems = this.dropdownItems.filter(item =>
      item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  isSelected(key: number): boolean {
    return this.selectedItems.includes(key);
  }

  toggleSelection(item: { key: number, name: string }) {
    if (this.isSelected(item.key)) {
      this.selectedItems = this.selectedItems.filter(k => k !== item.key);
    } else {
      this.selectedItems.push(item.key);
    }
    this.onChange(this.selectedItems);
    this.checkSelectAllState();
  }

  removeItem(key: number) {
    this.selectedItems = this.selectedItems.filter(k => k !== key);
    this.onChange(this.selectedItems);
    this.checkSelectAllState();
  }

  toggleSelectAll() {
    if (this.selectAllChecked) {
      this.selectedItems = this.dropdownItems.map(item => item.key);
    } else {
      this.selectedItems = [];
    }
    this.onChange(this.selectedItems);
  }

  checkSelectAllState() {
    this.selectAllChecked = this.selectedItems.length === this.dropdownItems.length;
  }

  toggleDropdown(event: MouseEvent) {
    this.dropdownVisible = !this.dropdownVisible;
     // Ensure selectAllChecked is updated based on actual selected items
    this.checkSelectAllState(); 
    event.stopPropagation();
  }

  getItemName(key: number): string {
    const item = this.dropdownItems.find(i => i.key === key);
    return item ? item.name : '';
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    if (!this.elementRef.nativeElement.contains(targetElement)) {
      this.dropdownVisible = false;
    }
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    if (Array.isArray(value)) {
      this.selectedItems = value;
      this.checkSelectAllState();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}
}
